// functions/src/ops/service.ts 응답 형태
export interface OpsOverview {
  generatedAt: string;
  cdnBase: string;
  firestore: { collections: { id: string; count: number; contentVisible: boolean }[] };
  searchImages: { total: number; distinctTags: number; paths: { path: string; count: number }[]; problemCount: number };
  r2: {
    total: number;
    totalBytes: number;
    byPrefix: { prefix: string; count: number; bytes: number }[];
    nonWebpImages: string[];
    releases: string[];
    latest: { releaseId?: string; latestAppVersion?: string; [k: string]: unknown } | null;
    catalogResourceCount: number;
  } | null;
  links: {
    searchMissingInR2: string[];
    catalogMissingInR2: string[];
    sharedKeys: string[];
    unreferencedImages: string[];
  } | null;
}

export interface SearchImageRow {
  docId: string;
  displayName: string;
  sourceLabel: string;
  tags: string[];
  imageUrl: string | null;
  path: string | null;
  fileId: string | null;
  key: string | null;
  problems: string[];
}

export type Reference = 'catalog' | 'search' | 'both' | 'none';

export interface ImageObjectRow {
  key: string;
  size: number;
  lastModified: string | null;
  url: string;
  reference: Reference;
  searchDocIds: string[];
}

export const REFERENCE_LABEL: Record<Reference, string> = {
  catalog: '기본 카드',
  search: '검색 이미지',
  both: '둘 다',
  none: '참조 없음',
};

export const formatBytes = (n: number) => (n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
